import { c as _c } from "react/compiler-runtime";
import { useAppKit, useAppKitState } from '@reown/appkit/react';
import React from 'react';
import { useConnection, useDisconnect, useConnectionEffect } from 'wagmi';
export default function useWallet() {
  const $ = _c(16);
  const {
    open
  } = useAppKit();
  const {
    open: isOpen
  } = useAppKitState();
  const {
    disconnect
  } = useDisconnect();
  const [isModalOpening, setIsModalOpening] = React.useState(false);
  const [isClientLoaded, setIsClientLoaded] = React.useState(false);
  const isConnectionStarted = React.useRef(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIsClientLoaded(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  React.useEffect(t0, t1);
  let t2;
  if ($[2] !== open) {
    t2 = async () => {
      setIsModalOpening(true);
      await open();
      setIsModalOpening(false);
      isConnectionStarted.current = true;
    };
    $[2] = open;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleConnect = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = t4 => {
      isConnectionStarted.current = false;
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleAccountConnected = t3;
  let t4;
  if ($[5] !== disconnect) {
    t4 = () => {
      disconnect();
    };
    $[5] = disconnect;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleDisconnect = t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      onConnect: handleAccountConnected
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  useConnectionEffect(t5);
  const {
    address,
    isDisconnected
  } = useConnection();
  const isWalletConnected = isClientLoaded && !isDisconnected && address !== undefined;
  const t6 = address || "";
  let t7;
  if ($[8] !== handleConnect || $[9] !== handleDisconnect || $[10] !== isModalOpening || $[11] !== isOpen || $[12] !== isWalletConnected || $[13] !== open || $[14] !== t6) {
    t7 = {
      openModal: open,
      isWalletConnected,
      address: t6,
      connect: handleConnect,
      disconnect: handleDisconnect,
      isModalOpening,
      isModalOpen: isOpen
    };
    $[8] = handleConnect;
    $[9] = handleDisconnect;
    $[10] = isModalOpening;
    $[11] = isOpen;
    $[12] = isWalletConnected;
    $[13] = open;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}